// @ts-nocheck
import React, { useState } from 'react';
import Audits from '../slideout/Audits';
import Add from '../slideout/Add';
import { toast } from 'react-toastify';
import { isPowerUser } from '../../auth/authUtils';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import icons from '../../../constants/icons';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks';

export interface AuditButtonProps {
  id: any;
  getAudit: any;
  addAudit: any;
}
function AuditButton({ id, getAudit, addAudit }: AuditButtonProps) {
  const { t } = useTranslation();
  const currentUser = useAppSelector((state) => state.auth);
  const [auditReload, setAuditReload] = useState();
  const [auditSlideoutOpen, setAuditSlideoutOpen] = useState(false);
  const [addAuditSlideoutOpen, setAddAuditSlideoutOpen] = useState(false);

  return (
    isPowerUser(currentUser) && (
      <>
        <Button
          onClick={() => setAuditSlideoutOpen(true)}
          className="btn btn-default btn--square ms-2"
          text={t('Open audit')}
          icon={icons.AUDIT}
          hideTitle={true}
        />
        <SlidingPane
          isOpen={auditSlideoutOpen}
          hideHeader={true}
          from="right"
          className="large-side-panel"
          onRequestClose={() => setAuditSlideoutOpen(false)}
        >
          <Audits
            id={id}
            getAudit={getAudit}
            addAudit={() => setAddAuditSlideoutOpen(true)}
            reload={auditReload}
            done={() => setAuditSlideoutOpen(false)}
            cancel={() => setAuditSlideoutOpen(false)}
          />
        </SlidingPane>

        <SlidingPane
          isOpen={addAuditSlideoutOpen}
          hideHeader={true}
          from="right"
          className="side-panel"
          onRequestClose={() => setAuditSlideoutOpen(false)}
        >
          <Add
            id={id}
            done={(d) => {
              addAudit(id, d.comment)
                .then(() => {
                  setAuditReload(new Date());
                  setAddAuditSlideoutOpen(false);
                })
                .catch((e) => {
                  toast.error(t('Failed to add comment'));
                });
            }}
            cancel={() => setAddAuditSlideoutOpen(false)}
          />
        </SlidingPane>
      </>
    )
  );
}
export default AuditButton;
